import React, { useEffect, useState } from "react";
import "./Forms.css";
import { Container, Button, Card, Col, Row, Form } from "react-bootstrap";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { GetCustomerAllReports } from "../../apis/ReportsAPI";
import { GetFormDetail } from "../../apis/FormAPI";
import dateFormat from "dateformat";
import { CreateOrder } from "../../apis/OrderAPI";
import * as BsIcons from "react-icons/bs";
import { GetBase64 } from "../../utils/Utility";
import { useAlert } from "react-alert";
import Loader from "../../components/Loader";
import { useSelector } from "react-redux";
import { GetRequestorAddresses } from "../../apis/RequestorAPI";

export default function ApplicationWebForm() {
  const { user } = useSelector((state) => state.auth);
  const [searchParams] = useSearchParams();
  const applicationId = searchParams.get("id");

  const defaultReport = {
    report_name: "Choose Report...",
    report_id: "0",
  };

  const [orderData, setOrderData] = useState({
    orderAddressId: { value: 0, invalid: false, initial: true },
    billingInfo: { value: "", invalid: false, initial: true },
    report: { value: defaultReport, invalid: false, initial: true },
    otherRemark: { value: "", invalid: false, initial: true },
    orderInstruction: { value: "", invalid: false, initial: true },
    attachments: { value: [], invalid: false, initial: true },
  });

  const updateOrderData = (key, value, rf = selectedReportFor) => {
    setOrderData((prevState) => ({
      ...prevState,
      [key]: {
        ...prevState[key],
        value,
        initial: false,
        invalid:
          key === "report" &&
          value.report_id === "0" &&
          (rf.includes("individual") ||
            rf.includes("corporate") ||
            rf.length === 0)
            ? true
            : key === "attachments" && value.length === 0
            ? true
            : key === "otherRemark" && rf.includes("other") && value === ""
            ? true
            : key !== "report" &&
              key !== "attachments" &&
              key !== "otherRemark" &&
              value === ""
            ? true
            : key === "orderAddressId" && value === 0
            ? true
            : false,
      },
    }));
  };

  const isObjectValid = (obj) => {
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        if (
          key !== "billingInfo" &&
          key !== "orderInstruction" &&
          key !== "attachments"
        ) {
          if (obj[key].invalid) {
            return false; // Invalid value found
          } else if (obj[key].initial) {
            updateOrderData(key, obj[key].value);
            return false;
          }
        }
      }
    }
    return true; // All properties have valid values
  };

  const [selectedReportFor, setSelectedReportFor] = useState([]);
  const [reqAddrs, setReqAddrs] = useState([]);

  const defaultReqAddr = {
    id: 0,
    address: "Choose address...",
  };

  const [selectedReqAddr, setSelectedReqAddr] = useState(defaultReqAddr);

  const [reportList, setReportList] = useState([]);
  const [formData, setFormData] = useState([]);
  const [showLoader, setShowLoader] = useState(false);
  const navigate = useNavigate();
  const alert = useAlert();

  async function GetCustomerReports() {
    var result = await GetCustomerAllReports(user.customerid);
    var data = result.data.filter(
      (r) => r.report_id !== 800 && r.report_template_id != 2
    );
    setReportList(data);
  }

  async function GetApplicationDetail() {
    var result = await GetFormDetail(applicationId);
    var data = result.data;
    setFormData(data);
  }

  async function GetReqAddress() {
    var result = await GetRequestorAddresses(user.requestorid);
    var data = result.data;
    var addrs = [];
    data.map((item) => {
      addrs.push({ id: item.id, address: item.streetAddress });
    });
    setReqAddrs(addrs);
  }

  useEffect(() => {
    GetApplicationDetail();
    GetCustomerReports();
    GetReqAddress();
  }, []);

  function handleFileChange(event) {
    const files = Array.prototype.slice.call(event.target.files);
    let uploadFiles = [];
    let msg = "";
    files.some((file) => {
      if (
        file.size <= 25000000 &&
        !file.type.includes("application/x-msdownload")
      ) {
        GetBase64(file, (result) => {
          uploadFiles.push({
            documentName: file.name.split(".").slice(0, -1).join("."),
            documentPath: result,
          });
        });
      } else msg += `${file.name} exceeds the limit of 25mb.`;
    });
    if (msg !== "") alert.error(msg);
    else {
      updateOrderData("attachments", uploadFiles);
    }
  }

  function showDocument(data) {
    var wndw = window.open("", "_blank");
    setTimeout(() => {
      wndw.document.write(
        "<iframe width='100%' height='640px' src='" +
          data +
          "#toolbar=0" +
          "'></iframe>"
      );
      wndw.document.title = data.documentName;
    }, 0);
    setTimeout(function () {
      wndw.stop();
    }, 1000);
  }

  async function generateOrder(e) {
    if (!isObjectValid(orderData)) {
      e.preventDefault();
      e.stopPropagation();
    } else {
      var data = {
        id: 0,
        totalRows: 0,
        orderApplicantName: formData.applicantName,
        orderCoApplicant: "",
        orderCustomerName: "",
        orderCustomerIdRef: user.customerid,
        orderUserIdRef: user.userid,
        orderRequestorIdRef: user.requestorid,
        orderAddress: formData.applicantAddress,
        orderNotes: "",
        orderStartDate: "",
        orderEndDate: "",
        orderPo: "",
        orderInvestigatorId: 0,
        investigatorName: "",
        orderAmount: "0",
        orderStatusId: 1,
        orderStatusName: "",
        orderPrelimReportDate: "",
        orderTimestamp: "",
        miscPrice: JSON.stringify([]),
        userName: "",
        requestorName: "",
        reportId: orderData.report.value.report_id,
        reportsName: "",
        reports: JSON.stringify([]),
        individual: selectedReportFor.includes("individual"),
        corporate: selectedReportFor.includes("corporate"),
        other: selectedReportFor.includes("other"),
        otherRemark: orderData.otherRemark.value,
        adminInstruction: "",
        customerInstruction: orderData.orderInstruction.value,
        billingInformation: orderData.billingInfo.value,
        applicantFormId: formData.id,
        attachments: orderData.attachments.value,
        requestorAddressId: orderData.orderAddressId.value,
      };

      setShowLoader(true);
      var result = await CreateOrder(data);
      if (result.status === 200) {
        alert.success("Order Created.", {
          onClose: () => {
            navigate("/Customer/Orders");
          },
        });
      } else
        alert.error("Error! Unable to create order", {
          onClose: () => setShowLoader(false),
        });
    }
  }

  const handleCheckboxChange = (event) => {
    const value = event.target.value;
    var srf = [];
    if (selectedReportFor.includes(value)) {
      srf = selectedReportFor.filter((option) => option !== value);
      setSelectedReportFor(srf);
    } else {
      srf = [...selectedReportFor, value];
      setSelectedReportFor(srf);
    }
    updateOrderData("report", orderData.report.value, srf);
    updateOrderData("otherRemark", orderData.otherRemark.value, srf);
  };

  const handleOrderAddress = (e) => {
    console.log(e);
    setSelectedReqAddr(e);
    updateOrderData("orderAddressId", e.id);
  };

  return (
    <>
      <Container className="mb-5">
        <Row className="page-head-row">
          <Col lg={6} md={6} sm={12}>
            <div className="page-title">
              <h2>Submit Application Webform as an Order</h2>
            </div>
          </Col>
          <Col lg={6} md={6} sm={12}>
            <div className="search-filter"></div>
          </Col>
        </Row>

        <Row>
          <Col lg={12}>
            <Card className="orderdetails-card form-other-pages">
              <div className="card-head">
                <div className="card-title h5">
                  <span>Form:</span> {formData.formNo}
                </div>
                <Link to="/Customer/Orders" className="back-btn">
                  <BsIcons.BsArrowLeft />
                </Link>
              </div>
              <Row>
                <Col lg={7} md={12}>
                  <div className="orderdetails-info application-webForm">
                    <div className="orderdetails-info-list">
                      <span>Status:</span> New
                    </div>
                    <div className="orderdetails-info-list">
                      <span>Form Date:</span>{" "}
                      {dateFormat(formData.creationDate, "mm/dd/yyyy")}
                    </div>
                    <div className="orderdetails-info-list">
                      <span>Order Address:</span>
                      <div class="billing-info">
                        <DropDownList
                          className="form-control custom-form-control-select"
                          data={reqAddrs}
                          textField="address"
                          dataItemKey="id"
                          defaultItem={defaultReqAddr}
                          value={selectedReqAddr}
                          onChange={(e) => handleOrderAddress(e.target.value)}
                        />
                        <div
                          className="invalid-dropdown"
                          hidden={
                            !orderData.orderAddressId.invalid ||
                            orderData.orderAddressId.initial
                          }
                        >
                          required
                        </div>
                      </div>
                    </div>
                    <div className="orderdetails-info-list">
                      <span>Applicant:</span> {formData.applicantName}
                    </div>
                    <div className="orderdetails-info-list">
                      <span>Address:</span> {formData.applicantAddress}
                    </div>
                    <div className="orderdetails-info-list">
                      <span>Application Form(s):</span>
                      <p>
                        <Link
                          to={`/Form?token=view&id=${formData.formTemplateId}&applicationid=${formData.id}`}
                          target="_blank"
                        >
                          View Form
                        </Link>
                      </p>
                    </div>
                    <div className="orderdetails-info-list">
                      <span>Billing Information:</span>
                      <div className="billing-info">
                        <Form.Group
                          className="mb-3"
                          controlId="exampleForm.ControlTextarea1"
                        >
                          <Form.Control
                            as="textarea"
                            rows={3}
                            value={orderData.billingInfo.value}
                            onChange={(e) =>
                              updateOrderData("billingInfo", e.target.value)
                            }
                          />
                        </Form.Group>
                      </div>
                    </div>
                  </div>
                </Col>
                <Col lg={5} md={12}>
                  <div className="orderdetails-info submit-order">
                    <div className="orderdetails-info-list">
                      <span>Report Type:</span>
                      <DropDownList
                        className="form-control custom-form-control-select"
                        data={reportList}
                        textField="report_name"
                        dataItemKey="report_id"
                        defaultItem={defaultReport}
                        value={orderData.report.value}
                        onChange={(e) =>
                          updateOrderData("report", e.target.value)
                        }
                      />
                      <div
                        className="invalid-dropdown"
                        hidden={
                          !orderData.report.invalid || orderData.report.initial
                        }
                      >
                        required if report for indiv/corp
                      </div>
                    </div>
                    <div className="orderdetails-info-list">
                      <span>Report For:</span>
                      <div className="chkbx">
                        <Form.Group controlId="ReportFor" className="mb-3">
                          <Form.Check
                            type="checkbox"
                            inline
                            label="Individual"
                            value="individual"
                            checked={selectedReportFor.includes("individual")}
                            onChange={handleCheckboxChange}
                          />
                          <Form.Check
                            type="checkbox"
                            inline
                            label="Corporate"
                            value="corporate"
                            checked={selectedReportFor.includes("corporate")}
                            onChange={handleCheckboxChange}
                          />
                          <Form.Check
                            type="checkbox"
                            inline
                            label="Other"
                            value="other"
                            checked={selectedReportFor.includes("other")}
                            onChange={handleCheckboxChange}
                          />
                          {selectedReportFor.includes("other") && (
                            <>
                              <Form.Control
                                as="textarea"
                                rows={3}
                                placeholder="Other Remark"
                                value={orderData.otherRemark.value}
                                onChange={(e) =>
                                  updateOrderData("otherRemark", e.target.value)
                                }
                                isInvalid={
                                  orderData.otherRemark.invalid &&
                                  !orderData.otherRemark.initial
                                }
                              />
                              <Form.Control.Feedback type="invalid">
                                required if chosen other
                              </Form.Control.Feedback>
                            </>
                          )}
                        </Form.Group>
                      </div>
                    </div>
                    <div className="orderdetails-info-list">
                      <span>Attachment(s):</span>
                      <Form.Group controlId="formFile" className="mb-3">
                        <Form.Control
                          type="file"
                          onChange={handleFileChange}
                          multiple
                        />
                      </Form.Group>
                      {orderData.attachments.value.map((item) => (
                        <p>
                          <Link onClick={() => showDocument(item.documentPath)}>
                            {item.documentName}
                          </Link>
                        </p>
                      ))}
                    </div>
                    <div className="orderdetails-info-list">
                      <span>Other Instructions:</span>
                      <div className="other-intruction">
                        <Form.Group
                          className="mb-3"
                          controlId="exampleForm.ControlTextarea1"
                        >
                          <Form.Control
                            as="textarea"
                            rows={3}
                            value={orderData.orderInstruction.value}
                            onChange={(e) =>
                              updateOrderData(
                                "orderInstruction",
                                e.target.value
                              )
                            }
                          />
                        </Form.Group>
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col className="text-center mt-5">
                  <Button
                    type="button"
                    className="view-report-btn"
                    onClick={generateOrder}
                  >
                    Submit as Order
                    <Loader visible={showLoader} ibutton={true} />
                  </Button>
                </Col>
              </Row>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}
